import { render, staticRenderFns } from "./flowAreaWorkList.vue?vue&type=template&id=66509712&"
import script from "./flowAreaWorkList.vue?vue&type=script&lang=js&"
export * from "./flowAreaWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports